import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import querystring from "querystring";
import { logOut } from "../auth/authActions";

const useAuthenticationCheck = (url = "") => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();

  const handleNotAuthenticated = error => {
    if (error.status === 401 || error.status === 403) {
      const searchParams = querystring.parse(search.substring(1));

      console.log("handleNotAuthenticated....");
      console.log("For URL: ", url);
      console.log(
        "Unauthorized, dispatching LOG_IN, redirectPath: %O, oAuthCode: %O",
        pathname,
        searchParams.code,
      );

      dispatch(logOut());
    }
  };

  return handleNotAuthenticated;
};

export { useAuthenticationCheck };
